import { CircleDot, Cog, Box, CheckCircle2, Package, ShieldCheck } from 'lucide-react';
import product1Img from '../assets/images/regenerated_image_1778485893446.webp';
import product2Img from '../assets/images/regenerated_image_1778486102604.jpg';
import product3Img from '../assets/images/regenerated_image_1778486103913.webp';
import precisionBg from '../assets/images/regenerated_image_1778495542308.jpg';
import mountedUnitsBg from '../assets/images/regenerated_image_1778495544368.jpg';
import React from 'react';

export interface ProductRange {
  id: string;
  title: string;
  desc: string;
  longDesc: string;
  icon: React.ReactNode;
  image: string;
}

export const productRanges: ProductRange[] = [
  { 
    id: "ball-bearings",
    title: "Ball Bearings", 
    desc: "Deep groove, self-aligning, and angular contact series for high-speed, general-purpose applications.", 
    longDesc: "Our Ball Bearings offer unmatched performance in high-speed applications. They are designed to reduce rotational friction and support radial and axial loads. They are highly durable and are essential for electric motors, automotive applications, and household appliances.",
    icon: <CircleDot size={20} />, 
    image: product1Img 
  },
  { 
    id: "roller-bearings",
    title: "Roller Bearings", 
    desc: "Cylindrical, tapered, and spherical rollers designed to support immense radial and heavy-duty loads.", 
    longDesc: "Roller Bearings are engineered to handle heavy loads with minimal friction. Ideal for mining, construction, and heavy machinery, they distribute loads across a larger surface area compared to ball bearings, ensuring stability and longevity in tough environments.",
    icon: <Cog size={20} />, 
    image: product2Img 
  },
  { 
    id: "thrust-bearings",
    title: "Thrust Bearings", 
    desc: "Specialized bearings designed to handle high axial loads for automotive and industrial machinery.", 
    longDesc: "Designed specifically to support axial loads, our Thrust Bearings are crucial for automotive, marine, and aerospace applications. We offer various types, including ball, cylindrical, and tapered formulations to fit specific load and speed requirements.",
    icon: <Box size={20} />, 
    image: product3Img 
  },
  { 
    id: "precision-bearings",
    title: "Precision Bearings", 
    desc: "High-grade industrial variants ensuring strict tolerances for core manufacturing processes.", 
    longDesc: "For applications demanding the highest accuracy and rigidity, our Precision Bearings are the ideal choice. Used in machine tools and robotics, they ensure exact positioning and smooth rotation even at exceptionally high speeds.",
    icon: <CheckCircle2 size={20} />, 
    image: precisionBg 
  },
  { 
    id: "mounted-units",
    title: "Mounted Units", 
    desc: "Secure plummer blocks and flanged housings for heavy conveyor and agricultural operations.", 
    longDesc: "Provide robust support for rotating shafts with our Mounted Units. Available in various housing styles like pillow blocks and flanged units, they are pre-lubricated and designed for easy installation, widely used in conveyors and agricultural machinery.",
    icon: <Package size={20} />, 
    image: mountedUnitsBg 
  },
  { 
    id: "custom-solutions",
    title: "Custom Solutions", 
    desc: "Tailored bearing assemblies and high-heat ceramic solutions for extremely demanding environments.", 
    longDesc: "When standard bearings don't meet your needs, our Custom Solutions are available. We provide specialized bearing assemblies, materials like ceramics for high-heat environments, and bespoke designs to solve your unique engineering challenges.",
    icon: <ShieldCheck size={20} />, 
    image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&q=80&w=600" 
  }
];
